import React, { useEffect, useState,useContext } from 'react';
import { FormContextProvider } from '@stormwater-software/lib-form';
import { FormModal } from '../../Shared/form';
import styles from './Permissions.module.scss';
import Toggle from '../../Shared/Toggle/toggle';
import notificationApi from '../../../utils/api/notifications';
import TenantFeatureContext from '../../../contexts/TenantContext'

export default function Permissions(props) {
    const [notifications, setNotifications] = useState([])
    const [toggleValue, setToggleValue] = useState({})
    const [notificationTypes, setNotificationTypes] = useState([])
    const { tenantHasFeature } = useContext(TenantFeatureContext)
    const obj = {}

    useEffect(() => {
        (async () => {
            setNotifications(props.notifications)
            for (const notification of props.notifications) {
                if (notification.is_enabled.length > 0) {
                    obj[notification.id] = true
                }
                else {
                    obj[notification.id] = false
                }
            }
            setToggleValue(obj)
        })();
    }, [])

    const handleSubmit = async () => {
        // Nothing toggled: close rather than send an empty list, which the API rejects.
        if (!notificationTypes.length) {
            props.hideModal()

            return
        }

        const arrayDetails = []

        notificationTypes.forEach((e) => {
            if (e.toggle) {
                arrayDetails.push({
                    isEnabled: [
                        "in-app",
                        "email"
                    ],
                    typeId: e.notificationId
                })
            }
            else {
                arrayDetails.push({
                    isEnabled: [],
                    typeId: e.notificationId
                })
            }
        })
        // Returned so FormActions waits on the save and shows the server's message in the
        // modal if it fails, rather than the modal sitting there with nothing happening.
        return notificationApi.blukUpdateTypeSetting(props.userId, arrayDetails).then(() => {
            props.refetch()
            props.hideModal()
        })
    }

    const handleNotificationTypes = (notificationId, toggle) => {
        let match = false
        const elementsArray = notificationTypes.length ? notificationTypes.map((ele) => {
            if (notificationId === ele.notificationId) {
                match = true

                return null
            }

            return ele
        }) : []
        const filteredNotifications = elementsArray.filter(e => e)

        if (!match) {
            filteredNotifications.push({ notificationId: notificationId, toggle: toggle })
        }

        return filteredNotifications
    }

    // SW2-2417: its own form context. Rendered inside the Edit User page's form, FormActions
    // validated the *page* on save, so a user invited but not yet registered, with no first
    // name, last name, position or phone, could never save their notification settings.
    return (
        <FormContextProvider>
        <FormModal
            modalProps={{
                title: 'Notifications'
            }}
            onSubmit={handleSubmit}
            onCancel={props.hideModal}
        >
            <div>
                <h3 className={styles.permissionsModalHeader}>Notifications</h3>
                <div className={styles.rowContainer}>
                    {notifications && notifications.map((notification, index) => {
                        // SW2-2417: only the precipitation row depends on the tenant feature. Gating
                        // every row's checked state on it rendered all of them off, and a click on a
                        // toggle that looked off queued the opposite change. Matches My Profile.
                        const precipitationLocked = notification.name === 'Daily Precipitation Notification' && !tenantHasFeature('Precipitation Notification')

                        return (
                            <div className={styles.singleRow} key={index} >
                                <h4>{notification.name}</h4>
                                <Toggle isChecked={toggleValue[notification.id] && !precipitationLocked}
                                    disabled={precipitationLocked}
                                    handleChange={() => setToggleValue((state) => {
                                    setNotificationTypes(handleNotificationTypes(notification.id, !toggleValue[notification.id]))

                                    return {
                                        ...state,
                                        [notification.id]: !toggleValue[notification.id]
                                    }

                                })} id={notification.id} />
                            </div>
                        )
                    })}


                </div>
            </div>
        </FormModal>
        </FormContextProvider>
    )
}
